import { IconButton } from '@mui/material';
import styled from 'styled-components';

export const VoiceMainButton = styled.button<{ $isConnected: boolean }>`
  min-width: 15px;
  padding: 6px 7px;
  border: none;
  border-radius: 4px;
  background-color: #1976d2;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;

  &:hover:not(:disabled) {
    background-color: #115293;
  }

  &:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    cursor: default;
  }

  svg {
    height: 18px;
    color: white;
    animation: ${props =>
      props.$isConnected ? 'pulse 1.5s infinite' : 'none'};
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const VoiceControlsContainer = styled.div<{ $primaryColor: string }>`
  border: 1px solid ${props => props.$primaryColor};
  border-radius: 4px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  height: 30px;
  background-color: white;
`;

export const VoiceControlButton = styled.button`
  font-size: 12px;
  border: none;
  background: transparent;
  padding: 4px 8px;
  cursor: pointer;
  color: #1976d2;
  transition: background-color 0.3s ease;

  &:hover:not(:disabled) {
    background-color: rgba(25, 118, 210, 0.08);
  }

  &:disabled {
    color: rgba(0, 0, 0, 0.26);
    cursor: default;
    background: transparent;
  }
`;

export const PoweredByLink = styled.a`
  text-decoration: none;
  color: inherit;
  padding: 4px 8px;
  display: flex;
  align-items: center;
`;

export const PoweredByText = styled.div`
  font-size: 12px;

  span:first-child {
    color: rgba(0, 0, 0, 0.7);
  }
`;

export const CloseIconButton = styled(IconButton)`
  padding: 2px !important;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 10px;
  outline: none;
  border-radius: 4px;
  resize: none;
  font-size: 14px;
  font-weight: 400;
`;
